import { render } from "./HistoryTabComponent.vue?vue&type=template&id=7c2d83f1"
import script from "./HistoryTabComponent.vue?vue&type=script&lang=js"
export * from "./HistoryTabComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__